import React, {useEffect, useState} from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import api from "@api/tracker-policy";
import VideoContentsDashboardSearch from "@components/tracker-policies/Dashboard/Search";
import ReportList from '@components/tracker-policies/Dashboard/List';
import ClicksChart from "@components/tracker-policies/Dashboard/ClicksChart";
import PriceChart from "@components/tracker-policies/Dashboard/PriceChart";
import {BASE_URL} from "@api/client";
import {useSelector} from 'react-redux';


function TrackerPolicyDashboardPage() {
  const [state, setState] = useState({
    isFetched: false,
    downloadUrl: "",
    data : []
  });
  
  const access_token = useSelector(reduxState => reduxState.auth.access_token);
  
  useEffect(() => {
    fetch()
  }, []);
  
  const fetch = (searchParams={}) => {
    let url = `${BASE_URL}/tracker-policies/clicks/_report`;
    const {["count"]: omit, ...rest } = searchParams || {};
    url += `?${new URLSearchParams({...rest, access_token}).toString()}`;
  
    api.getDashboardReport({
        params: {...searchParams}
      })
      .then(({data, meta}) => {
        setState({
          isFetched: true,
          downloadUrl: url,
          data
        })
      })
      .catch()
  };
  
  return (
    <Row gutter={16}>
      {!!state.downloadUrl && (
        <Col span={24}>
          <div className={'report'}>
            <a href={state.downloadUrl}>
              <Button type={"primary"}>
                <Icon type="file-excel"/>
                <FormattedMessage
                  id="app.download_excel_file"
                  defaultMessage={`Download Excel File`}
                />
              </Button>
            </a>
          </div>
        </Col>
      )}
  
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <VideoContentsDashboardSearch search={fetch}/>
        </Card>
      </Col>
      <Col span={24}>
        {state.data.length > 0 && (
          <Row gutter={12}>
            <Col span={12}>
              <ClicksChart data={state.data}/>
            </Col>
  
            <Col span={12}>
              <PriceChart data={state.data}/>
            </Col>
          </Row>
        )}
        
        <ReportList
          loading={!state.isFetched}
          data={state.data}/>
      </Col>
    </Row>
  )
}

export default TrackerPolicyDashboardPage;

